import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as echarts from 'echarts';
import { useTheme } from '@emotion/react';
import { jsx as ___EmotionJSX } from "@emotion/react";

var EChart = function EChart(_ref) {
  var option = _ref.option,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 300 : _ref$height,
      style = _ref.style;
  var containerRef = useRef();
  var chartRef = useRef();
  var theme = useTheme();
  useEffect(function () {
    if (!containerRef.current) return;
    chartRef.current = echarts.init(containerRef.current);
    var resizeObserver = new ResizeObserver(function () {
      var _chartRef$current;

      (_chartRef$current = chartRef.current) === null || _chartRef$current === void 0 ? void 0 : _chartRef$current.resize();
    });
    resizeObserver.observe(containerRef.current);
    return function () {
      var _chartRef$current2;

      resizeObserver.disconnect();
      (_chartRef$current2 = chartRef.current) === null || _chartRef$current2 === void 0 ? void 0 : _chartRef$current2.dispose();
    };
  }, []);
  useEffect(function () {
    if (!chartRef.current || !option) return;
    var baseOption = {
      backgroundColor: 'transparent',
      textStyle: {
        color: theme.gray500,
        fontFamily: 'Inter, sans-serif'
      }
    };
    chartRef.current.setOption(_objectSpread(_objectSpread({}, baseOption), option), true);
  }, [option, theme]);
  return ___EmotionJSX("div", {
    ref: containerRef,
    style: _objectSpread({
      width: '100%',
      height: height
    }, style)
  });
};

EChart.propTypes = {
  option: PropTypes.object,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object
};
export default EChart;